type RequestKey = string;

const inFlightRequests = new Map<RequestKey, Promise<any>>();

export const preventDuplicateRequest = <T>(
  key: RequestKey,
  apiCall: () => Promise<T>
): Promise<T> => {
  if (inFlightRequests.has(key)) {
    return inFlightRequests.get(key) as Promise<T>;
  }

  const promise = apiCall()
    .then((res) => res)
    .catch((err) => {
      throw err;
    })
    .finally(() => {
      inFlightRequests.delete(key);
    });

  inFlightRequests.set(key, promise);

  return promise;
};